angular.module('dpw.services').factory('PostMessageHost', ['$window', '$q', function ($window, $q) {
    var DEFAULT_TARGET_ORIGIN = '*';

    var EVENT_TYPES = {
        EVENT: 'event',
        HANDLE: 'handle',
    };

    var RESPONSE_CODES = {
        SUCCESS: 200,
        ERROR: 400,
        TIMEOUT: 500,
    };

    return createPostMessageHost();

    function createPostMessageHost() {
        function PostMessageHost(options) {
            options = options || {};

            this.id = new Date().valueOf();
            this.contentWindow = null;
            this.targetOrigin = DEFAULT_TARGET_ORIGIN;
            this.eventMap = {};
            this.onMessage = this.onMessage.bind(this);

            $window.addEventListener('message', this.onMessage);

            if (!options.contentWindow) {
                throw new Error('contentWindow is required');
            }

            this.contentWindow = options.contentWindow;
            this.targetOrigin = options.targetOrigin || this.targetOrigin;
        }

        PostMessageHost.prototype.send = function (channel, payload) {
            var data = {
                type: EVENT_TYPES.EVENT,
                channel: channel,
                payload: payload,
            };

            this.contentWindow.postMessage(data, this.targetOrigin);
        };

        PostMessageHost.prototype.on = function (channel, listener) {
            this.eventMap[channel] = listener;
        };

        PostMessageHost.prototype.once = function (channel, listener) {
            var self = this;

            self.eventMap[channel] = function (payload, messageEvent) {
                self.removeListener(channel);
                listener(payload, messageEvent);
            };
        };

        PostMessageHost.prototype.invoke = function (channel, payload) {
            var data = {
                type: EVENT_TYPES.HANDLE,
                channel: channel,
                payload: payload,
            };

            var messageChannel = new MessageChannel();
            this.contentWindow.postMessage(data, this.targetOrigin, [messageChannel.port2]);

            return $q(function (resolve, reject) {
                messageChannel.port1.onmessage = function (messageEvent) {
                    var response = messageEvent.data || {};

                    if (response.code === RESPONSE_CODES.SUCCESS) {
                        resolve(response);
                    } else {
                        reject(response);
                    }

                    messageChannel.port1.close();
                };

                messageChannel.port1.onmessageerror = function (messageEvent) {
                    var response = _.assign({}, messageEvent.data, {
                        code: RESPONSE_CODES.ERROR,
                        error: 'onmessageerror'
                    });

                    reject(response);
                    messageChannel.port1.close();
                };
            });
        };

        PostMessageHost.prototype.removeListener = function (channel) {
            delete this.eventMap[channel];
        };

        PostMessageHost.prototype.dispose = function () {
            $window.removeEventListener('message', this.onMessage);
        };

        PostMessageHost.prototype.onMessage = function (messageEvent) {
            var data = messageEvent.data;
            var channel = data.channel;
            var payload = data.payload;

            var listener = this.eventMap[channel];

            if (typeof listener === 'function') {
                listener(payload, messageEvent);
            }
        };

        return PostMessageHost;
    }
}]);
